import { render, staticRenderFns } from "./shangPuGuanLi.vue?vue&type=template&id=93b60112&scoped=true&"
import script from "./shangPuGuanLi.vue?vue&type=script&lang=js&"
export * from "./shangPuGuanLi.vue?vue&type=script&lang=js&"
import style0 from "./shangPuGuanLi.vue?vue&type=style&index=0&id=93b60112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b60112",
  null
  
)

export default component.exports